<template>
  <modal name="common-alert-modal"
         :width="`100%`"
         :height="276"
         :min-width="480"
         :min-height="276"
         :pivotX="0.5"
         :pivotY="0.5"
         :delay="100"
         :clickToClose="false"
         @before-open="beforeOpen"
  >
    <vue-scroll>
      <div class="FloatMenu md_overlay md_overlay_0 ">
        <div class="modal modal_0">
          <div class="md_content">
            <span class="md_close">
                <img
                    src="/images/union.svg"
                    alt=""
                    @click="modalClose"
                />
            </span>
            <ul class="message">
              <li v-for="line in this.message"
                  :key="line"
              >
                {{ line }}
              </li>
            </ul>
            <div class="confirmBtn">
              <a class="btn blue btn_basics pointer no-drag" @click="modalClose">
                {{ this.$t('status.ok') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </vue-scroll>
  </modal>
</template>

<script>
export default {
  name: 'commonAlert',
  components: {},
  props: [''],
  data() {
    return {
      message: '',
      longMessage1: '',
      longMessage2: '',
      function: function () {
        // This is intentional
      },
      funcParams: []
    }
  },
  methods: {
    modalClose: function (event) {
      this.message = '';
      this.longMessage1 = '';
      this.longMessage2 = '';
      this.function(...this.funcParams);
      this.$modal.hide('common-alert-modal');
      event?.stopPropagation();
      event?.preventDefault();
    },
    beforeOpen(event) {
      switch (event.params.messageType) {
        case 'short' :
          this.message = [this.$t(event.params.message)];
          break;
        case 'lineBreak' :
          this.message = this.$t(event.params.message).split('\n').map(line => line);
          break;
        default :
          this.message = [this.$t('alert.unexpected_error')];
          break;
      }
      if (event.params.funcParams) { // 전달받은 함수가 파라메터가 있는 경우
        this.funcParams = event.params.funcParams;
      }
      this.function = event.params?.function ?? function () {
        // This is intentional
      };
    }
  }
}
</script>
<style lang="scss">
.v--modal-overlay[data-modal="common-alert-modal"] {
  .md_overlay {
    background: none;
  }

  .message {
    height: 156px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    li {
      color: var(--grey100);
      font-size: 20px;
      font-weight: 700;
      line-height: 1.3;
      text-align: center;
      word-break: keep-all;
    }
  }

  .confirmBtn {
    display: flex;

    a {
      margin: 0 auto;
      max-width: 200px;
    }
  }

  .v--modal {
    box-shadow: none;
  }

  .md_content {
    height: 270px;
    width: 480px;
  }
}
</style>


